import { fmtTime, getPlainTxt, countDown } from "libs/tool";
import RecordRTC from "recordrtc";
import STEvaluation from "libs/STEvaluation";
import WavEncoder from "wav-encoder";

let disabled = false;
const duration = 300; //限定5分钟
let time = 0;
let timer;
let audio = {};
const levelArr = [
  {
    icon: "https://llss-file.langsounds.com/miniapp/05f8df7acb2c7b2fd738554aee47809f.png",
    txt: "表现很棒哦！向着完美进发吧！",
  },
  {
    icon: "https://llss-file.langsounds.com/miniapp/5e9e2833d5fc22c4bc049068037aba7d.png",
    txt: "表现不错哦！继续加油！",
  },
  {
    icon: "https://llss-file.langsounds.com/miniapp/c651e4e64cc3251f9764dfa87a2a5c6e.png",
    txt: "要加油哦，你还可以做的更好！",
  },
  {
    icon: "https://llss-file.langsounds.com/miniapp/28790cae6946271af68e1969e1c77eca.png",
    txt: "要加油哦~别灰心，加强练习，期待你的进步！",
  },
];

export default {
  data() {
    return {
      isGlobal: false,
      isRecord: false,
      isEnd: false,
      isRecording: false,
      isUserTrigger: false,
      recordRate: 0,
      recorder: null,
      audioContext: null,
      count: 0,
      meter: "00:00",
      allMeter: "05:00",
      recorderManager: null,
      evalResult: {},
    };
  },
  mounted() {
    this.recorderManager = new STEvaluation({
      onScore: (res) => {
        if (!res.result) {
          this.$confirm(``, {
            zIndex: 2100,
            title: "分析服务异常",
            content: res.error,
            okText: "重试",
            onOk: () => {
              this.handleEvaluate();
            },
          });
        } else {
          const total = res.overall;
          const level = total > 89 ? 0 : total > 79 ? 1 : total > 59 ? 2 : 3;
          const levelObj = levelArr[level];
          this.evalResult = {
            ...levelObj,
            status: true,
            audioUrl: audio.blobUrl,
          };
          res.levelObj = levelObj;
          res.audioUrl = audio.blobUrl;
          sessionStorage.setItem("evalReport", JSON.stringify(res));
        }
        this.$loading.hide();
      },
    });
    this.globalAudio.addEventListener("timeupdate", (e) => {
      if(!this.isEnd) return;
      this.meter = fmtTime(this.globalAudio.currentTime);
      
      if(this.globalAudio.duration) {
        // this.allMeter = fmtTime(this.globalAudio.duration);
        audio.duration = this.globalAudio.duration;
      }
      this.recordRate = Math.ceil(
        (this.globalAudio.currentTime / this.globalAudio.duration) * 100
      );
    });
    this.audioBackFuns = {
      onEnd: () => {
        this.meter = "00:00";
        this.recordRate = 0;
      },
    };
  },
  methods: {
    // fmtTime,
    startRecording() {
      if (this.isRecord) return this.keepOrPauseRecord();
      if (disabled) return;
      disabled = true;
      navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
        this.recorder = RecordRTC(stream, {
          type: "audio", // 录制音频
          // mimeType: 'audio/mp3', // 指定格式为 MP3
          recorderType: RecordRTC.StereoAudioRecorder,
        });

        this.count = 3;
        setTimeout(() => {
          countDown(3, (t) => {
            // if (!disabled) {
            if (!t) this.handleStart();
            this.count = t;
            // }
          });
        }, 1000);
      });
    },
    keepOrPauseRecord() {
      if (this.isRecording) {
        this.recorder?.pauseRecording();
        this.stopMeter();
      } else {
        this.recorder?.resumeRecording();
        this.startMeter();
      }
      this.isRecording = !this.isRecording;
      // status ? this.recorder?.resumeRecording() : this.recorder?.pauseRecording()
    },
    handleStart() {
      this.recorder.startRecording();
      this.isRecord = true;
      this.isRecording = true;
      this.startMeter();
      disabled = false;
      // 设定规定时间后自动停止录音,5分钟
      // this.recorder.setRecordingDuration(duration);
    },
    startMeter() {
      const [m, s] = this.allMeter?.split(":");
      const limitTime = this.isEnd ? +m * 60 + +s : duration;
      this.stopMeter();
      timer = setInterval(() => {
        time++;
        this.recordRate = Math.round((time / limitTime) * 100);
        this.meter = fmtTime(time);
        // 5分钟自动暂停
        if (time === limitTime) {
          if (this.isEnd) {
            this.recordRate = 0;
            this.meter = "00:00";
            this.resetMeter();
          } else {
            this.finishRecord();
            this.$toast("录制时长已满，已自动结束录制");
          }
        }
      }, 1000);
    },
    resetRecord(isReset = false) {
      this.isEnd = false;
      this.isRecord = false;
      this.isRecording = false;
      this.recordRate = 0;
      this.meter = "00:00";
      if (isReset) this.allMeter = "05:00";
      this.globalAudio?.pause();
      this.recorder && this.recorder?.reset();
      sessionStorage.removeItem("evalReport");
      this.evalResult = {};
      this.resetMeter();
    },
    stopMeter() {
      clearInterval(timer);
      timer = 0;
    },
    resetMeter() {
      this.stopMeter();
      time = 0;
    },
    finishRecord() {
      if (!this.isSingle && Number(this.meter.replace(":", "")) < 10)
        return this.$toast("录制时长不能少于10秒哦");
      this.recorder.stopRecording((audioURL) => {
        const blob = this.recorder.getBlob();
        // audio.blob = URL.createObjectURL(blob);
        audio = {
          audioURL,
          blobUrl: URL.createObjectURL(blob),
          blob,
          url: audioURL,
        };
        this.isRecording = false;
        this.allMeter = this.meter;
        this.resetRecord();
        this.isEnd = true;
        // window.open(audioURL);
        console.log("--------大小", blob.size);
        this.convertToWAV(blob);
        // 导出音频
        // RecordRTC.invokeSaveAsDialog(this.audioBlob);
      });
    },
    // 录音 → 降采样 → WAV 导出
    async convertToWAV(blob, targetSampleRate = 16000) {
      // 创建 Web Audio 上下文
      const audioContext = new AudioContext();
      const arrayBuffer = await blob.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

      // 降采样处理（从 48kHz → 16kHz 或 8kHz）
      const offlineContext = new OfflineAudioContext(
        1,
        audioBuffer.duration * targetSampleRate,
        targetSampleRate
      );
      const source = offlineContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(offlineContext.destination);
      source.start(0);

      // 渲染新音频数据
      const renderedBuffer = await offlineContext.startRendering();

      this.encodeWAV(renderedBuffer);
    },
    // 使用 wav-encoder 编码 WAV
    async encodeWAV(audioBuffer) {
      const sampleRate = audioBuffer.sampleRate;
      const channelData = audioBuffer.getChannelData(0); // 取第一声道

      const wavData = await WavEncoder.encode({
        sampleRate,
        channelData: [channelData], // 只保存单声道
      });

      audio.blob = new Blob([wavData], { type: "audio/wav" });
      console.log(`转换后 WAV 大小: ${(audio.blob.size / 1024).toFixed(2)} KB`);

      if (this.curDevice.isPreview) this.handleEvaluate();
    },
    downBlob(isSm) {
      isSm ? RecordRTC.invokeSaveAsDialog(audio.blob) : window.open(audio.audioURL);
    },
    handleEvaluate() {
      if (this.artObj.count < 4)
        return this.$toast("无法测评，文章字数少于4个汉字");
      if (this.artObj.count > 1000)
        return this.$toast("无法测评，文章字数超过1000个汉字");
      this.globalAudio?.pause();
      this.$emit('onStart') //关闭点读的原音频播放
      if (Object.keys(this.evalResult).length) {
        this.$set(this.evalResult, "status", true);
      } else {
        this.$loading.show("AI分析作品中", 3);
        this.recorderManager.start(
          getPlainTxt(this.artObj.content),
          audio.blob
        );
      }
    },
    handlePlay() {
      this.$emit('onStart')
      // this.changeStatus('https://llss-file.langsounds.com/course/4886fce6fe5285f1b76c6d87addf3010.mp3');
      this.changeStatus(audio.blobUrl);
    },
    changeAudio(e) {
      if (!this.isPlaying || !this.isUserTrigger) return;
      const curDur = (e / 100) * audio.duration;
      this.globalAudio.currentTime = curDur;
    },
    handleMouse(bol) {
      this.isUserTrigger = bol;
    },
    delRecord() {
      this.recorder?.destroy();
      this.recorder = null;
      this.resetRecord(true);
    },
  },
  destroyed() {
    this.delRecord();
  },
};
